'use strict';

class SearchResults extends HTMLUListElement {
    static get observedAttributes() {
        return ['results'];
    }

    constructor() {
        super();
        this.baseURL = this.getAttribute('base-url');
        this.template = this.template.bind(this);
    }

    template(suggestion) {
        return `
            <li class="p-2">
            <a class="border-0 d-block" href="${this.baseURL}&q=${suggestion.suggestion}">${suggestion.formatted}</a>
            </li>
        `;
    }

    attributeChangedCallback(attrName, oldValue, newValue) {
        if (oldValue === newValue) return;

        this.innerHTML = '';
        const links = JSON.parse(newValue).map(this.template);
        this.insertAdjacentHTML('afterbegin', links.join(''));
    }
}

export default SearchResults;

customElements.define('vz-search-results', SearchResults, { extends: 'ul' });
